import Image from 'next/image'
import classNames from 'classnames'
import { descriptionMultiCols } from '../sharedTypes'
import { CFImage } from '@/data/portfolio/type/client-index'

export type HorizontalImagesShowcaseProps = {
  title: string
  description: descriptionMultiCols
  images: CFImage[]
  shadow?: Boolean
  respectImageDimension?: Boolean
  subtitle?: string
  variant?: number
}

export default function HorizontalImagesShowcase({
  title,
  description,
  images,
  shadow = false,
  respectImageDimension = false,
  subtitle = '',
  variant = 1
}: HorizontalImagesShowcaseProps) {
  return (
    <>
      <div className="mx-auto px-6 sm:px-8 md:h-full md:max-h-[62rem] md:px-0 md:py-24">
        <div className="h-full md:flex md:flex-col md:justify-between">
          <div>
            <div className="md:mx-auto md:max-w-2xl">
              <h2 className="font-serif text-5xl font-bold">{title}</h2>
              <h3 className="font-medium uppercase">{subtitle}</h3>
              <div className="hy mt-4 space-y-6 md:flex md:space-y-0 md:space-x-8">
                {description.content.map((thisContent) => (
                  <p key={thisContent} className="hyphenate flex-1 font-light leading-relaxed">
                    {thisContent}
                  </p>
                ))}
              </div>
            </div>
          </div>
          <div className="relative mt-6 flex h-full flex-col items-end justify-center space-y-4 md:mt-0 md:flex-row md:space-x-12 md:px-24">
            {images.map((thisImage, index) => (
              <div
                key={thisImage.url}
                className={classNames('relative overflow-hidden', `image-container-${index}`, { 'shadow-xl': shadow })}>
                <Image src={thisImage.url} layout="fill" className="absolute object-cover" objectFit="cover" />
              </div>
            ))}
            {variant === 1 && (
              <>
                <div
                  aria-hidden="true"
                  className="absolute -bottom-20 -left-8 -z-10 hidden h-36 w-72 rounded-b-full bg-orange-200 md:block"
                />
                <div
                  className="absolute top-[-250px] -right-4 -z-10 hidden h-[600px] w-[300px] rounded-l-full border-4 border-blue-200 bg-transparent md:block"
                  aria-hidden="true"
                />
              </>
            )}
          </div>
        </div>
      </div>
      {images.map((thisImage, index) => {
        const imageRatio = thisImage.height / thisImage.width
        const heightPercentage = 0.8

        const innerCalc = `(((100vw - 12rem) - (2rem * ${images.length - 1})) / ${images.length})`

        // MMM, should probably do a fixed height and calcul the width

        if (respectImageDimension) {
          return (
            <style key={thisImage.url}>{`
              .image-container-${index} {
                width: 100%;
                padding-bottom: 100%;
              }
              @media (min-width: 768px) {
                .image-container-${index} {
                  padding-bottom: 0;
                  width: calc(${innerCalc} * ${heightPercentage});
                  height: calc(${innerCalc} * ${imageRatio} * ${heightPercentage});
                }
              }
            `}</style>
          )
        }
        return (
          <style key={thisImage.url}>{`
            .image-container-${index} {
              width: 100%;
              padding-bottom: 100%;
            }
            @media (min-width: 768px) {
              .image-container-${index} {
                padding-bottom: 0;
                  width: 100%;
                  height: 80%;
              }
            }
          `}</style>
        )
      })}
    </>
  )
}
